import Api from "./api";
import OidcManager from "./oidcManager";
import {Bookmark} from "../state/bookmark";

export default class BookmarksApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address);
    }

    searchBookmarks(loadOptions: DevExpress.data.LoadOptions): JQueryPromise<{ totalCount: number, data: { id: number, text: string, sectionTitle: string, page: number, index: number, estimateId: number, costbookId: number }[] }> {

        let command = this.loadOptionsToActionParams(loadOptions, false);

        return super.get("/api/bookmarks", command);
    }

    createBookmark(command: { text: string, sectionTitle: string, pageNumber: number, rowNumber: number, estimateId: number, costbookId: number }): JQueryPromise<Bookmark> {

        return super.put("/api/bookmarks", command);
    }

    deleteBookmark(command: { index: number, estimateId: number, costbookId: number }): JQueryPromise<{}> {

        return super.delete("/api/bookmarks", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/bookmarks.ts